/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const locationDataSchema = z.object({
	city: z.string().nullable(),
	country: z.string().nullable(),
	state: z.string().nullable(),
	street1: z.string().nullable(),
	street2: z.string().nullable(),
	zipCode: z.string().nullable(),
	raw: z.string().nullable(),
})

export type LocationDataSchema = z.infer<typeof locationDataSchema>
